import { FC, useEffect } from 'react';
import { FeatureCollection, GeoJsonProperties, Point } from 'geojson';
import { SxProps } from '@mui/material';
import { Map as GoogleMap } from '@vis.gl/react-google-maps';
import { prefersDarkMode } from '@carcareers/theme';
import { useGeocode } from '@carcareers/hooks';

import Heatmap from './Heatmap';
import { Pin } from './Pin';
interface MapProps {
  heatmapData?: FeatureCollection<Point, GeoJsonProperties>;
  location?: string;
  zoom?: number;
  pin?: boolean;
  disableControls?: boolean;
  sx?: SxProps;
}

export const Map: FC<MapProps> = ({
  heatmapData,
  sx,
  location = '',
  zoom = 4.5,
  pin = false,
  disableControls = false,
}) => {
  const lightMapId = 'e1b4d755da45ac7a';
  const darkMapId = '7a9e2ebecd32a903';
  const mapId = prefersDarkMode ? darkMapId : lightMapId;
  const { center, geocode } = useGeocode(36, -95);

  const style = {
    width: '100%',
    height: '500px',
    ...(sx as unknown as object),
  };

  const mapCenterZoomProps = disableControls ? { center, zoom } : { defaultCenter: center, defaultZoom: zoom };

  useEffect(() => {
    if (location) {
      geocode(location);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <>
      <GoogleMap
        mapId={mapId}
        {...mapCenterZoomProps}
        disableDefaultUI={true}
        style={style}
        zoomControl={!disableControls}
        disableDoubleClickZoom={disableControls}
        gestureHandling={disableControls ? 'none' : 'greedy'}
      >
        {pin && <Pin />}
      </GoogleMap>

      {heatmapData && <Heatmap geojson={heatmapData} radius={40} opacity={1} />}
    </>
  );
};
